import React, { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { ImagePlus, Move, Pencil } from 'lucide-react';

export default function ProfilePhotoActions({ target, usable, disabled, onAdjust, onChange }) {
  const [anchor, setAnchor] = useState(null);
  const closeThen = (action) => { setAnchor(null); action(); };
  return <>
    <button type="button" className={`profile-photo-icon profile-photo-actions profile-photo-actions--${target}`}
      aria-label={`Edit ${target === 'avatar' ? 'profile' : 'cover'} photo`} title="Edit photo"
      aria-haspopup="menu" aria-expanded={Boolean(anchor)} disabled={disabled}
      onClick={(event) => { event.stopPropagation(); setAnchor(event.currentTarget); }}><Pencil size={17} /></button>
    <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
      {usable && <MenuItem onClick={() => closeThen(onAdjust)}><Move size={17} style={{ marginRight: 10 }} />Adjust photo</MenuItem>}
      <MenuItem onClick={() => closeThen(onChange)}><ImagePlus size={17} style={{ marginRight: 10 }} />{usable ? 'Change photo' : 'Add photo'}</MenuItem>
    </Menu>
  </>;
}
